import { render, staticRenderFns } from "./OrganisationNotes.vue?vue&type=template&id=e4cd82e6&"
import script from "./OrganisationNotes.vue?vue&type=script&lang=js&"
export * from "./OrganisationNotes.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationNotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports